import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

interface FilterSelectProps {
  label: string;
  value: string;
  options: string[];
  allLabel?: string;
  onChange: (value: string) => void;
  minWidth?: number;
}

export const SearchFilterBarSelect = ({
  label,
  value,
  options,
  allLabel = 'All',
  onChange,
  minWidth = 150,
}: FilterSelectProps) => {
  return (
    <FormControl size="small" sx={{ minWidth }}>
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={(e) => onChange(e.target.value)} sx={{ fontSize: '0.875rem' }}>
        <MenuItem value="">{allLabel}</MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
